/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { I18nCodeOption } from './I18nCodeOption';
import {
    I18nCodeOptionFromJSON,
    I18nCodeOptionFromJSONTyped,
    I18nCodeOptionToJSON,
    I18nCodeOptionToJSONTyped,
} from './I18nCodeOption';

/**
 * 
 * @export
 * @interface ResponseListI18nCodeOption
 */
export interface ResponseListI18nCodeOption {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListI18nCodeOption
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListI18nCodeOption
     */
    message?: string;
    /**
     * 
     * @type {Array<I18nCodeOption>}
     * @memberof ResponseListI18nCodeOption
     */
    data?: Array<I18nCodeOption>;
}

/**
 * Check if a given object implements the ResponseListI18nCodeOption interface.
 */
export function instanceOfResponseListI18nCodeOption(value: object): value is ResponseListI18nCodeOption {
    return true;
}

export function ResponseListI18nCodeOptionFromJSON(json: any): ResponseListI18nCodeOption {
    return ResponseListI18nCodeOptionFromJSONTyped(json, false);
}

export function ResponseListI18nCodeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListI18nCodeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(I18nCodeOptionFromJSON)),
    };
}

export function ResponseListI18nCodeOptionToJSON(json: any): ResponseListI18nCodeOption {
    return ResponseListI18nCodeOptionToJSONTyped(json, false);
}

export function ResponseListI18nCodeOptionToJSONTyped(value?: ResponseListI18nCodeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(I18nCodeOptionToJSON)),
    };
}

